import { render, staticRenderFns } from "./Step_3.vue?vue&type=template&id=19ed1be3&"
import script from "./Step_3.vue?vue&type=script&lang=ts&"
export * from "./Step_3.vue?vue&type=script&lang=ts&"
import style0 from "./Step_3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports